<script setup lang="ts">
import { ref } from 'vue'
import { useSyncStore } from '@/stores/sync'
import FadeTransition from '@/components/FadeTransition.vue'
import SyncModal from '@/components/SyncModal.vue'

const syncStore = useSyncStore()
const showSyncModal = ref(false)
</script>

<template>
  <div class="page home">
    <RouterLink class="move-container" :to="{ name: 'move-container' }">
      <img src="./assets/barcode.svg" alt="Code-barre" />
    </RouterLink>

    <FadeTransition>
      <div class="sync-wrapper" v-if="syncStore.hasDataToSync">
        <SuiButton class="sync-button" tertiary icon labeled="left" @click="showSyncModal = true">
          <SuiIcon name="sync" circular />
          {{ syncStore.dataToSync.length }} {{ syncStore.dataToSync.length === 1 ? 'donnée' : 'données' }} à synchroniser
        </SuiButton>
      </div>
    </FadeTransition>
    <SyncModal :show="showSyncModal" @hide="showSyncModal = false" />
  </div>
</template>

<style scoped lang="scss">
.home {
  position: relative;

  .move-container {
    height: 20dvh;
    max-width: 75%;
    position: absolute;
    top: 47.5%;
    left: 50%;
    transform: translate(-50%, -50%);

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .sync-wrapper {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translate(-50%);
    white-space: nowrap;

    .sync-button {
      color: var(--primary-color);
      font-size: 1.25rem;
      font-weight: normal;
    }
  }
}
</style>
